import { Component, OnInit, ViewChild } from '@angular/core';
import { LookupService } from '../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../services/lookups/lookupadmin.service';
import { Location } from '../../../models/user.model';
import { SelectItem  } from 'primeng/api';
import { DivisionDetailComponent } from './division-detail/division-detail.component';

@Component({
  selector: 'app-division',
  templateUrl: './division.component.html',
  styleUrls: ['./division.component.css']
})
export class DivisionComponent implements OnInit {
  divisions: Location[];
  locationNames:SelectItem[];
  parentLocationNames:SelectItem[];
  isActiveList:SelectItem[];
  displayDivisionDetailDlg:boolean;
  @ViewChild(DivisionDetailComponent) divisionDetail: DivisionDetailComponent;
  constructor(private lookupService: LookupService, private lookupAdminService: LookupAdminService) {}

  ngOnInit() {
    this.LoadAllDivisions();
    
  }

  private LoadAllDivisions() {
    this.lookupAdminService.getAllDivisions$().subscribe(data => {
      this.divisions = data;
      this.divisions.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
      this.locationNames = this.lookupAdminService.GetUniqueValues(this.divisions.map(p=>p.locationName));
      this.parentLocationNames = this.lookupAdminService.GetUniqueValues(this.divisions.map(p=>p.parentLocationName));
      var isActives = new Array<SelectItem>();
      isActives.push({ label: "Yes", value:true});
      isActives.push({ label: "No", value:false});
      this.isActiveList = isActives;
    });
  }
  
  ShowHideDivisionDetailDialog(isDisplay:boolean)
  {
    this.displayDivisionDetailDlg = isDisplay;
    //TODO: Add behaviour subject in the services to manage refresh of the table.
    //this.LoadAllDivisions();
    
  }
  showDivisionDetailDialog(location:any)
  {
     this.divisionDetail.showDivisionDetailDialog(location);
    this.ShowHideDivisionDetailDialog(true);
  }
  RefreshDataSource(isReload:boolean)
  {
    if(isReload)
     this.LoadAllDivisions();
  }


}



// WEBPACK FOOTER //
// ./src/app/admin/lookup-management/division/division.component.ts